export default {"src":"/_next/static/media/Linkedin.198c5524.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};